import classNames from "classnames";

export const wrapper = classNames("p-5", "bg-secondary", "text-white");
export const privacyText = classNames("w-full", "max-w-screen-lg", "m-auto", "text-center", "mt-5", "italic");
